import { Page } from "@/models/page-models/Page";

export const MiscLoadingManifest: Page = {
  "path": "misc-loading-manifest/:invoiceId",
  "name": "Micellaneous Loading Manifest",
  "props": {
    "data": {
      "title": "Micellaneous Loading Manifest",
      "printable": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.loadingManifestData.data.status}},'),!==,'Pending')",
      "url": "misc-loading-manifest/:invoiceId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestDetails",
                  "variable": "fetchedData.loadingManifestData.data",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.loadingManifestData.data}}",
                  "config": {
                    "customerDetailsVariable": "fetchedData.loadingManifestData.data.customer.id",
                    "billingAddressKey": "billingAddress",
                    "lmType": "misc"
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Lm Orders",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.loadingManifestData.data.orders}}",
                  "items": "fetchedData.loadingManifestData.data.orders",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.loadingManifestData.data.orders}}))"
                    },
                    {
                      "value": "product._id",
                      "text": "Item #\\n# المنتج",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "description",
                      "text": "Description\\nالتفاصيل"
                    },
                    {
                      "value": "__item.quantityA",
                      "text": "Quantity A\\nA الكمية",
                      "type": "formula",
                      "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.sellingUnit}})"
                    },
                    {
                      "value": "__item.quantityB",
                      "text": "Quantity B\\nB الكمية",
                      "type": "formula",
                      "formula": "N/A"
                    },
                    {
                      "value": "__item.quantityC",
                      "text": "Quantity C\\nC الكمية",
                      "type": "formula",
                      "formula": "N/A"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem;"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_LoadingManifestShippingDetails",
                  "variable": "fetchedData.loadingManifestData.data",
                  "label": "Shipping Details",
                  "config": {
                    "deliveryAddressRefVariable": "orders.0.order.deliveryLocation"
                  }
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "buttonType": "print",
                  "disabled": "FALSE",
                  "showIf": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.loadingManifestData.data.status}},'),!==,'Pending')",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true,
      "printDocDate": "{{fetchedData.loadingManifestData.data.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMiscellaneousLoadingManifest",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/misc-invoice/{{__params.invoiceId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.loadingManifestData"
        },
        "name": "getMiscellaneousLoadingManifest"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyLoadingManifestData",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "fetchedData.loadingManifestData.data.loadingManifest",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.loadingManifestData.data",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyLoadingManifestData"
      }
    ],
    "functions": []
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,GENERAL_MANAGER",
  "visible": false
}